export enum PARAMS {
    FORM_ID = "f",
    SUBMISSION_TOKEN = "s",
    STATION_ID = "st",
    MODE = "m",
    EVENT_WEB_ACCESS_TOKEN = "e",
    ACTIVATION_ID = "a",
    LANGUAGE = "l",
    ACTION_BTN_POSITION = "b",
    FORM_TYPE = "form_type", // template | device
    LAUNCHER = "launcher", // event_gen_mobile | event_gen_web,
    SUBMISSION_TYPE = "t", // to detect whether it's a drafted submission >> it's value normal | drafted
    SUBMIT_BUTTON_BOTTOM_PADDING = "sbbp",
    PLATFORM = "platform",
    HIDE_EMAIL = "he",
    CONNEXIONS_EMBED_MODE = "cem", // used when we don't want to redirect or download a vcard
    THEME = "theme", // force light or dark mode
    EMRO = "emro", // edit mode read only: locks email-mapped (when filled) and invitation code elements
    SHOW_TRANSCRIBE_BUTTON = "show_transcribe_button", // embedded hosts that answer transcribe_scanner_request
}

export enum LAUNCHER_TYPES {
    EVENT_GEN_MOBILE = "event_gen_mobile",
    EVENT_GEN_WEB = "event_gen_web",
    WEBAPP = "webapp",
    MMP = "MMP",
}

/** Event Gen hosts show the form's messages themselves: every toast goes to them instead. */
export function isEventGenLauncher(launcher: string | null): boolean {
    return launcher === LAUNCHER_TYPES.EVENT_GEN_MOBILE || launcher === LAUNCHER_TYPES.EVENT_GEN_WEB;
}

/**
 * Launchers whose host handles the form's outcome itself: a submission goes to it as
 * `submission_body`, and a refused submit as `form_error_message`.
 */
export function isEmbeddedLauncher(launcher: string | null): boolean {
    return isEventGenLauncher(launcher) || launcher === LAUNCHER_TYPES.MMP || launcher === LAUNCHER_TYPES.WEBAPP;
}

export enum PreviewPlatformVariants {
    web = "web",
    mobile = "mobile",
}
